import { render } from "./TheatreDayTab.vue?vue&type=template&id=0af1a2ca"
import script from "./TheatreDayTab.vue?vue&type=script&lang=js"
export * from "./TheatreDayTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__